<template>
    <div>
        <table style="width: 100%">
            <tr>
                <td>
                    <o-input v-model="filter" icon="filter" placeholder="Filter results" expanded clearable class="mb-4"></o-input>
                </td>
                <td class="has-text-right pt-1">
                    {{ $filters.AddCommas(companiesFiltered.length) }}
                    Companies
                </td>
            </tr>
        </table>

        <o-table :data="companiesFiltered" :paginated="companiesFiltered.length > perPage" :pagination-simple="true" :per-page="openColumns" :defaultSort="[sort, direction]" :sticky-header="true" hoverable>
            <template #empty>
                <h3 class="py-6">No companies match the filters</h3>
            </template>
            <o-table-column field="company" label="Company" v-slot="props" sortable>
                <router-link class="default-link" :to="{ name: '_companyDetail', params: { Id: props.row.Id } }"></router-link>
                <router-link target="_blank" :to="{ name: '_companyDetail', params: { Id: props.row.Id } }">
                    {{ props.row.company }}
                    <span v-if="props.row.IsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                </router-link>
            </o-table-column>
            <o-table-column field="parent" label="Subsidiary of" v-slot="props" sortable>
                <router-link target="_blank" :to="{ name: '_companyDetail', params: { Id: props.row.parentId } }">
                    {{ props.row.parent }}
                    <span v-if="props.row.parentIsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                </router-link>
            </o-table-column>
            <o-table-column field="owner" label="Owner" class="thin" v-slot="props" sortable>
                {{ props.row.owner }}
            </o-table-column>
            <o-table-column field="status" label="Status" v-slot="props" sortable>
                {{ props.row.status }}
            </o-table-column>
            <o-table-column field="offLimitsDate" label="Off limits date" sortable v-slot="props">
                <span v-if="props.row.offLimitsDate">
                    {{ $filters.OffLimitsDate(props.row.status, props.row.offLimitsDate) }}
                </span>
            </o-table-column>
        </o-table>
    </div>
</template>
<script>
import { ref, inject, watch, computed, onMounted, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";

export default {
    props: {
        data: {
            type: Array,
            default: () => {
                return [];
            }
        },
        sort: {
            type: String,
            default: "company"
        },
        direction: {
            type: String,
            default: "asc"
        },
        perPage: {
            type: Number,
            default: 50
        },
        infiniteScroll: {
            type: Boolean,
            default: false
        }
    },
    setup(props, context) {
        const $router = useRouter();
        const moment = inject("$moment");

        const companiesLocal = computed(() => props.data);
        const filter = ref("");

        const global = getCurrentInstance()?.appContext.config.globalProperties;

        const companiesFiltered = computed(() => {
            if (!filter.value || filter.value == "") {
                return companiesLocal.value;
            }

            const filterString = filter.value.toLowerCase();

            return companiesLocal.value.filter((x) => {
                if (
                    x.company?.toLowerCase().indexOf(filterString) >= 0 ||
                    x.parent?.toLowerCase().indexOf(filterString) >= 0 ||
                    x.owner?.toLowerCase().indexOf(filterString) >= 0 ||
                    x.status?.toLowerCase().indexOf(filterString) >= 0
                )
                    return true;
            });
        });

        const openColumns = ref(props.perPage);

        const RowClicked = (row, index) => {
            if (index == 0) return;
            const route = $router.resolve({ name: "_companyDetail", params: { Id: row.Id } });
            window.open(route.href);
        };

        if (props.infiniteScroll) {
            const main = document.getElementById("main");
            main.onscroll = function (event) {
                const element = event.target;

                if (element.scrollHeight - element.scrollTop <= element.clientHeight + 2) {
                    openColumns.value += props.perPage;
                }
            };
        }

        return { moment, filter, companiesFiltered, openColumns, RowClicked };
    }
};
</script>

